import React, { useEffect, memo } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { useInjectReducer } from 'utils/common/injectedReducers';
import { useInjectSaga } from 'utils/common/injectSaga';

import { Skeleton } from 'antd';
import classnames from 'classnames';

import reducer from 'pages/home/ribbon/asset-full/controllers/reducer';
import saga from 'pages/home/ribbon/asset-full/controllers/saga';
import { selectRibbonType } from '@redux/ribbon/selectors';
import * as ribbonActions from '@redux/ribbon/actions';

import advancedSearchReducer from 'pages/home/ribbon/advanced-search/controllers/reducer';
import advancedSearchSaga from 'pages/home/ribbon/advanced-search/controllers/saga';

import HomeBlank from 'pages/home/ribbon/HomeBlank';

import { useSlot } from 'common/components/slot';
import {
  getPreviousViewStyle,
  removeLocalViewTypeOnPageRefresh,
} from 'pages/home/utils';

import * as constant from 'static/Constants';

import './style.less';

const key = 'asset';

const Ribbon = ({ children }) => {
  const dispatch = useDispatch();

  useInjectReducer({ key, reducer });
  useInjectSaga({ key, saga });

  useInjectReducer({ key: 'advancedSearch', reducer: advancedSearchReducer });
  useInjectSaga({ key: 'advancedSearch', saga: advancedSearchSaga });

  const pathname = window.location.pathname;
  // Type view
  const typeView = useSelector(selectRibbonType());
  // selectors

  const { matchedChildren: ribbonChildren } = useSlot({
    name: 'ribbon',
    children,
  });

  const setPerviousView = () => {
    const { previousViewType, localViewType, routeUrl } =
      getPreviousViewStyle(typeView);

    if (routeUrl) {
      if (previousViewType) {
        if (previousViewType !== typeView) {
          dispatch(ribbonActions.changeType(previousViewType));
        } else {
          localStorage.setItem('view', JSON.stringify(localViewType));
        }
      } else {
        localStorage.setItem('view', JSON.stringify(localViewType));
        dispatch(ribbonActions.changeType(constant.RIBBON_TYPES.THUMBNAILS));
      }
    }
  };

  useEffect(() => {
    setPerviousView();
    // remove this if you don't want to reset your VIEW TYPE on page refresh.
    window.addEventListener('beforeunload', removeLocalViewTypeOnPageRefresh);
    return () => {
      window.removeEventListener(
        'beforeunload',
        removeLocalViewTypeOnPageRefresh
      );
    };
  }, [pathname, typeView]);

  return (
    <div
      className={classnames('ribbon', 'main__ribbon')}
      data-ribbon-ref
      style={{
        padding: '4px',
        lineHeight: 0,
      }}
    >
      <Skeleton
        className='ribbon__skeleton ribbon__sketelon--custom'
        paragraph={{
          rows: 1,
        }}
        loading={false}
      >
        {ribbonChildren?.length ? ribbonChildren[0] : <HomeBlank />}
      </Skeleton>
    </div>
  );
};

export default memo(Ribbon);
